export const PROSPECTS_CHANGE_TRACKING = {
  statusUpdate: {
    source: 'prospects.status_update',
    id: 25101,
  },
  bulkImport: {
    source: 'prospects.bulk_import',
    id: 25102,
  },
} as const;
